// push notification default
export var DEFAULT_CONFIG = {
    push: {
        status: "",
        updatedAt: ""
    },
    favouriteCategoryIds: []
};
